<div class="p-10 h-full">
    <nz-page-header class="text-[16px] font-semibold p-0 m-0" nzTitle="Razones de merma">
        <nz-page-header-extra class="flex items-center justify-items-end">
            <!------------------------------------------------>
            <!------------------- FILTER INPUT --------------->
            <div class="flex">
                <nz-input-group [nzPrefix]="searchIcon" [nzSuffix]="inputClearTpl"
                    class="rounded-lg border border-gray-300">
                    <input onfocus="select()"
                        class="block px-4 text-[15px] font-medium py-1 pl-10 w-[275px] text-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        placeholder="Nombre de la razón de merma" nz-input [(ngModel)]="filterText"
                        (keyup.enter)="getPaginatedLossReasons()" />
                </nz-input-group>
                <ng-template #inputClearTpl>
                    @if (filterText) {
                    <span class="ant-input-clear-icon" nzTheme="fill" nzType="close-circle" (click)="clearFilter()"
                        nz-icon></span>
                    }
                </ng-template>
                <ng-template #searchIcon>
                    <span nz-icon nzType="search"></span>
                </ng-template>
            </div>
            @if (canCreate()) {
            <div class="flex">
                <button class="ml-1 button primary-button" (click)="create()">
                    @if(innerWidth > WIDTH_VIEW_LIST_COMPONENT_ACTIONS){
                    Nuevo
                    }@else {
                    <span nz-icon nzType="plus"></span>
                    }
                </button>
            </div>
            }
        </nz-page-header-extra>
    </nz-page-header>

    <div #tableContainer class="mt-[15px] h-[calc(100%_-_100px)] max-h-[calc(100%_-_100px)]">
        <nz-table #lossReasonsTable nzTableLayout="fixed" [nzSize]="'small'" [nzData]="lossReasons"
            [nzLoading]="isLoading" [nzLoadingIndicator]="indicatorTemplate" [nzTotal]="totalLossReasons"
            [nzBordered]="true" [nzFrontPagination]="false" [nzScroll]="{ y: (tableHeight || 0) + 'px', x:'240px' }"
            nzShowSizeChanger [nzPageSize]="pageSize" [nzPageIndex]="pageIndex"
            (nzQueryParams)="onQueryParamsChange($event)">
            <thead>
                <tr>
                    <th nzWidth="200px">Nombre</th>
                    <th nzWidth="200px">Utilizada en </th>
                    @if (canRead() || canEdit() || canDelete()) {
                    <th nzWidth="150px">Acciones</th>
                    }
                </tr>
            </thead>
            <tbody>
                @for (loss of lossReasonsTable.data; track loss.id) {
                <tr>
                    <td>{{ loss.name }}</td>
                    <td>{{ loss._count?.losses ?? 0 }} {{loss._count?.losses &&
                        loss._count?.losses === 1 ? 'merma' : 'mermas'}}</td>
                    @if (canRead() || canEdit() || canDelete()) {
                    <td>
                        <div class="flex align-middle justify-center">
                            @if (canRead()) {
                            <button nz-button nzType="text" nzShape="circle" class="table-icon"
                                [nzTooltipTitle]="'Ver razón de merma'" nzTooltipPlacement="bottom" nz-tooltip
                                (click)="view(loss)">
                                <span nz-icon nzType="eye"></span>
                            </button>
                            @if (canEdit() || canDelete()) {
                            <nz-divider nzType="vertical"></nz-divider>
                            }
                            }
                            @if (canEdit()) {
                            <button nz-button nzType="text" nzShape="circle" class="table-icon"
                                [nzTooltipTitle]="'Editar razón de merma'" nzTooltipPlacement="bottom" nz-tooltip
                                (click)="edit(loss)">
                                <span nz-icon nzType="edit"></span>
                            </button>
                            @if (canDelete()) {
                            <nz-divider nzType="vertical"></nz-divider>
                            }
                            }

                            @if (canDelete()) {
                            <button nz-button nzType="text" nzShape="circle" class="table-icon"
                                [nzTooltipTitle]="'Eliminar razón de merma'" nzTooltipPlacement="bottom" nz-tooltip
                                (click)="delete(loss.id!)">
                                <span nz-icon nzType="delete"></span>
                            </button>
                            }
                        </div>
                    </td>
                    }
                </tr>
                }
            </tbody>
        </nz-table>
    </div>
</div>

<ng-template #indicatorTemplate>
    <app-loader></app-loader>
</ng-template>

<nz-drawer [nzClosable]="false" [nzVisible]="drawerVisible" nzPlacement="right" [nzTitle]="title" [nzFooter]="footer"
    (nzOnClose)="closeDrawer()" [nzPlacement]="innerWidth > DRAWER_WIDTH_CHANGE_PLACEMENT ? 'right':'bottom'"
    [nzWidth]="'500px'" [nzHeight]="innerWidth > DRAWER_WIDTH_CHANGE_PLACEMENT ? '' : '90%'"
    [nzMaskClosable]="fieldsReadOnly">
    <ng-template #title class="px-0 py-1 w-full grid grid-cols-2 gap-4 place-content-evenly">
        <div style="display: flex; align-items: center;">
            <p class="drawer-title"> {{ drawerTitle }} </p>
        </div>
    </ng-template>
    <ng-container *nzDrawerContent>
        <form nz-form [nzLayout]="'vertical'" [formGroup]="validateForm" (ngSubmit)="submitForm()">
            <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }" class="p-4">
                <nz-form-item nz-col nzXs="24" nzSm="24" nzMd="24" class="px-4">
                    <nz-form-label nzRequired>
                        Nombre
                    </nz-form-label>
                    <nz-form-control nzErrorTip="Indique un nombre para la razón de la merma">
                        <input onfocus="select()" nz-input placeholder="Indique un nombre para la razón de la merma"
                            type="text" id="name" formControlName="name" />
                    </nz-form-control>
                </nz-form-item>
            </div>
        </form>
    </ng-container>
    <ng-template #footer>
        <div class="flex justify-end">
            <button class="button secondary-button mr-2" (click)="closeDrawer()">
                Cancelar
            </button>

            @if (!fieldsReadOnly) {
                <button nz-button class="button primary-button" [disabled]="!validateForm.valid" (click)="submitForm()" [nzLoading]="isSaving">
                    Guardar
                </button>
            }
        </div>
    </ng-template>
</nz-drawer>